import { c as _c } from "react/compiler-runtime";
import { trackEvent } from '@/services/Analytics/BBAnalytics';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
interface IProps {
  label: string;
  href: string;
}
export const trackMouseDown = (event: MouseEvent, handler: () => void) => {
  /*
   * We use the `mousedown` event instead of `onClick` as `onClick` only fires for left click.
   * with `onClick` using the wheel button to open in a new tab would not trigger the event.
   * Right clicking (button === 2) a button to open up the context menu shouldn't trigger tracking
   */
  if (event.button !== 2) {
    return handler();
  }
};
export const TrackableExternalLink = t0 => {
  const $ = _c(6);
  const {
    label,
    href
  } = t0;
  let t1;
  if ($[0] !== href) {
    t1 = e => {
      trackMouseDown(e.nativeEvent, () => {
        trackEvent(TrackingAction.FollowLink, TrackingCategory.ExternalContent, href);
      });
    };
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== href || $[3] !== label || $[4] !== t1) {
    t2 = <a href={href} onMouseDown={t1}>{label}</a>;
    $[2] = href;
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};